import { loc } from '@/localization';

import { MessagePage } from './message';

export function FailedPage() {
    return <MessagePage message={loc.Login.RestorePasswordFailed} />;
}
